import Skid from "../../../assets/img/certifications/latest/skidsteer.svg";
import Excavation from "../../../assets/img/certifications/latest/excavation.svg";
import Demolitions from "../../../assets/img/certifications/latest/demolitions.svg";
import TreeRem from "../../../assets/img/certifications/latest/treeremovalists.svg";
import ConfinedSpace from "../../../assets/img/certifications/latest/confinedspace.svg";
import WTH from "../../../assets/img/certifications/latest/workatheights.svg";
import WWCC from "../../../assets/img/certifications/latest/wwcc.svg";
import WhiteCard from "../../../assets/img/certifications/latest/whitecard.svg";
import FirstAid from "../../../assets/img/certifications/latest/firstaid.svg";
import Asbestos from "../../../assets/img/certifications/latest/asbestos.svg";
import Airconditioning from "../../../assets/img/certifications/latest/airconditioning.svg";
import Refrigeration from "../../../assets/img/certifications/latest/refrigeration.svg";
import Electricals from "../../../assets/img/services/latest/electricals.svg";
import Plumber from "../../../assets/img/certifications/latest/plumbing.svg";
import GasFitter from "../../../assets/img/certifications/latest/gasfitter.svg";
import Engineering from "../../../assets/img/certifications/latest/engineering.svg";
import Surveying from "../../../assets/img/certifications/latest/surveying.svg";
import Cleaning from "../../../assets/img/certifications/latest/cleaning.svg";
import Envoirmental from "../../../assets/img/certifications/latest/envoirmental.svg";
import Insurance from "../../../assets/img/certifications/latest/insurance.svg";
import WorkCover from "../../../assets/img/certifications/latest/workcover.svg";
import BuildingContract from "../../../assets/img/certifications/latest/buildcontractor.svg";
import LandScaping from "../../../assets/img/certifications/latest/landscaping.svg";
import FireProtection from "../../../assets/img/certifications/latest/fireprotection.svg";
import TrafficManagement from "../../../assets/img/certifications/latest/trafficmanagement.svg";
import Scaffolding from "../../../assets/img/certifications/latest/scaffolding.svg";
import Waterproofing from "../../../assets/img/services/latest/waterproofing.svg";
import Roofing from "../../../assets/img/services/latest/roofing.svg";
import Handyman from "../../../assets/img/services/latest/handyman.svg";
import Concret from "../../../assets/img/services/latest/concrete.svg";
import Tiling from "../../../assets/img/services/latest/tiling.svg";
import Painting from "../../../assets/img/services/latest/painting.svg";
import Carpentery from "../../../assets/img/services/latest/carpenter.svg";

// import  from "../../../assets/img/certifications/latest/"
// import  from "../../../assets/img/certifications/latest/"
// import  from "../../../assets/img/certifications/latest/"

export const General = [
  {
    heading: "White Card",
    description:
      "Badge related information Badge related information badge related information",
    image: WhiteCard,
    status: "Add",
  },
  {
    heading: "ID Check",
    description:
      "Badge related information Badge related information badge related information",
    image: '',
    status: "Add",
  },
  {
    heading: "Police Check",
    description:
      "Badge related information Badge related information badge related information",
    image: '',
    status: "Add",
  },
  {
    heading: "Children Check",
    description:
      "Badge related information Badge related information badge related information",
    image: WWCC,
    status: "Add",
  },
  // {
  //   heading: "Insurance",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Insurance,
  //   status: "Add",
  // },
  // {
  //   heading: "Police check",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: PoliceCheck,
  //   status: "Add",
  // },
  // {
  //   heading: "Carpenter",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Carpenter,
  //   status: "Add",
  // },
  // {
  //   heading: "Waterproofing",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Waterproofing,
  //   status: "Add",
  // },

  // {
  //   heading: "Inspection",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Inspection,
  //   status: "Add",
  // },
  {
    heading: "First Aid",
    description:
      "Badge related information Badge related information badge related information",
    image: FirstAid,
    status: "Remove",
  },
  {
    heading: "CPR",
    description:
      "Badge related information Badge related information badge related information",
    image: '',
    status: "Add",
  },
  {
    heading: "Insurance",
    description:
      "Badge related information Badge related information badge related information",
    image: Insurance,
    status: "Add",
  },
  {
    heading: "Work Cover",
    description:
      "Badge related information Badge related information badge related information",
    image: WorkCover,
    status: "Add",
  },
  {
    heading: "Flat Pack",
    description:
      "Badge related information Badge related information badge related information",
    image: LandScaping,
    status: "Add",
  },
  {
    heading: "Handyman",
    description:
      "Badge related information Badge related information badge related information",
    image: Handyman,
    status: "Add",
  },
  // {
  //   heading: "Engineering",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Engineering,
  //   status: "Add",
  // },
  // {
  //   heading: "Surveying",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Surveying,
  //   status: "Add",
  // },
  // {
  //   heading: "Cleaning",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Cleaning,
  //   status: "Add",
  // },
  // {
  //   heading: "Health & Safety",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Cleaning,
  //   status: "Add",
  // },
  // {
  //   heading: "Tool Safety",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Cleaning,
  //   status: "Add",
  // },
  // {
  //   heading: "Risk Assessment",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Cleaning,
  //   status: "Add",
  // },
  // {
  //   heading: "Environmental",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Envoirmental,
  //   status: "Add",
  // },
  // {
  //   heading: "Project Management",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Cleaning,
  //   status: "Add",
  // },
  // {
  //   heading: "Building Contractor",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: BuildingContract,
  //   status: "Add",
  // },
  // {
  //   heading: "Roofing",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Roofing,
  //   status: "Add",
  // },
  // {
  //   heading: "Waterproofing",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: WaterProofing,
  //   status: "Add",
  // },
  // {
  //   heading: "Landscaping",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: LandScaping,
  //   status: "Add",
  // },

  // {
  //   heading: "Contract Insurance",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Cleaning,
  //   status: "Add",
  // },
  // {
  //   heading: "Warranty Insurance",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Cleaning,
  //   status: "Add",
  // },
];
export const Licensed = [
  {
    heading: "Plumbing",
    description:
      "Badge related information Badge related information badge related information",
    image: Plumber,
    status: "Add",
  },
  {
    heading: "Drainage",
    description:
      "Badge related information Badge related information badge related information",
    image: "",
    status: "Add",
  },
  {
    heading: "Gas Fitting",
    description:
      "Badge related information Badge related information badge related information",
    image: GasFitter,
    status: "Add",
  },
  {
    heading: "Electrical",
    description:
      "Badge related information Badge related information badge related information",
    image: Electricals,
    status: "Add",
  },
  {
    heading: "Air Conditioning",
    description:
      "Badge related information Badge related information badge related information",
    image: Airconditioning,
    status: "Remove",
  },
  {
    heading: "Refrigeration",
    description:
      "Badge related information Badge related information badge related information",
    image: Refrigeration,
    status: "Add",
  },

  {
    heading: "Fire Protection",
    description:
      "Badge related information Badge related information badge related information",
    image: FireProtection,
    status: "Add",
  },
  {
    heading: "Asbestos Removal",
    description:
      "Badge related information Badge related information badge related information",
    image: Asbestos,
    status: "Add",
  },
  {
    heading: "Demolition",
    description:
      "Badge related information Badge related information badge related information",
    image: Demolitions,
    status: "Add",
  },
  {
    heading: "Builder",
    description:
      "Badge related information Badge related information badge related information",
    image: "",
    status: "Add",
  },
  {
    heading: "Building Contractor",
    description:
      "Badge related information Badge related information badge related information",
    image: "",
    status: "Add",
  },
  {
    heading: "Concreting",
    description:
      "Badge related information Badge related information badge related information",
    image: Concret,
    status: "Add",
  },
  {
    heading: "Wall & Floor Tiling",
    description:
      "Badge related information Badge related information badge related information",
    image: Tiling,
    status: "Add",
  },
  {
    heading: "Painting",
    description:
      "Badge related information Badge related information badge related information",
    image: Painting,
    status: "Add",
  },
  {
    heading: "Roofing",
    description:
      "Badge related information Badge related information badge related information",
    image: Roofing,
    status: "Add",
  },
  {
    heading: "Carpentry",
    description:
      "Badge related information Badge related information badge related information",
    image: Carpentery,
    status: "Add",
  },
  {
    heading: "Waterproofing",
    description:
      "Badge related information Badge related information badge related information",
    image: Waterproofing,
    status: "Add",
  },
];
export const Tickets = [
  {
    heading: "Scaffolding",
    description:
      "Badge related information Badge related information badge related information",
    image: Scaffolding,
    status: "Add",
  },
  {
    heading: "Working at Heights",
    description:
      "Badge related information Badge related information badge related information",
    image: WTH,
    status: "Add",
  },
  {
    heading: "Skid Steer",
    description:
      "Badge related information Badge related information badge related information",
    image: Skid,
    status: "Add",
  },
  {
    heading: "Excavation",
    description:
      "Badge related information Badge related information badge related information",
    image: Excavation,
    status: "Add",
  },
  {
    heading: "Confined Space",
    description:
      "Badge related information Badge related information badge related information",
    image: ConfinedSpace,
    status: "Add",
  },
  {
    heading: "Elevated Work Platform",
    description:
      "Badge related information Badge related information badge related information",
    image: "",
    status: "Add",
  },
  {
    heading: "Asbestos Awareness",
    description:
      "Badge related information Badge related information badge related information",
    image: "",
    status: "Add",
  },
  {
    heading: "Tree Removalist",
    description:
      "Badge related information Badge related information badge related information",
    image: TreeRem,
    status: "Add",
  },
  // {
  //   heading: "Demolitions",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Demolitions,
  //   status: "Add",
  // },
  // {
  //   heading: "Traffic Management",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: TrafficManagement,
  //   status: "Add",
  // },
  // {
  //   heading: "Crane Operation",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Asbestos,
  //   status: "Add",
  // },
  // {
  //   heading: "Rigging",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Asbestos,
  //   status: "Add",
  // },
  // {
  //   heading: "Welding",
  //   description:
  //     "Badge related information Badge related information badge related information",
  //   image: Asbestos,
  //   status: "Add",
  // },
];
